module.exports = __webpack_public_path__ + "images/Plus_Icon.svg";